import C from "@/modules/location/CountryFlag.module.css";

import { getIso2CountryInfo, getIso3CountryInfo } from "@/modules/location/locationCountry.ts";
import { basepath } from "@/modules/main/urls.ts";

function getFlagUrl(iso2: string) {
    return `${basepath}/flags/${iso2.toLowerCase()}.svg`;
}

export function CountryFlag({ code, className = C.countryFlag }: { code?: string; className?: string }) {
    const country = code && getIso3CountryInfo(code);
    if (country) {
        return <img src={getFlagUrl(country.code.iso2)} alt={country.name} className={className} />;
    }

    return <CountryFlagPadding className={className} />;
}

export function CountryFlagPadding({ className = C.countryFlagPadding }: { className?: string }) {
    return <div className={className} />;
}

export function CountryFlagTitle({ code, className = C.countryFlag }: { code?: string | null; className?: string }) {
    const country = code && getIso2CountryInfo(code);
    if (country) {
        return (
            <div className="flex gap-0.5rem items-center">
                <img src={getFlagUrl(country.code.iso2)} alt={country.name} className={className} />
                {country.name}
            </div>
        );
    }

    return null;
}
